const e = {
  name: "RevenueProtect",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.995 23.147L12 23.15H11.99L11.995 23.147Z" fill="currentColor"/>
<path d="M8.07 20.79L11.995 23.147L15.92 20.79C17.08 20.09 18.09 19.19 18.9 18.1C20.25 16.3 20.99 14.08 20.99 11.83V4.42C20.99 3.77 20.63 3.18 20.05 2.89C15.01 0.37 8.98 0.37 3.94 2.89C3.36 3.18 3 3.77 3 4.42V11.83C3 14.08 3.74 16.3 5.09 18.1C5.9 19.19 6.91 20.09 8.07 20.79ZM5 11.83V4.6C9.18218 2.57545 14.0871 2.47522 18.3408 4.29932L6.30259 16.3376C5.45871 14.9974 5 13.4213 5 11.83ZM7.56547 17.8951L19 6.47761V11.82C19 13.64 18.4 15.44 17.31 16.89C16.65 17.77 15.84 18.5 14.9 19.07L12 20.81L9.1 19.07C8.54114 18.7371 8.02823 18.344 7.56547 17.8951Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as RevenueProtect
};
